// extracted by mini-css-extract-plugin
export default {"Container":"Summary_Container__aeY8e","info":"Summary_info__bWYKy"};